const M2 = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <rect
      x="2.25"
      y="2.25"
      width="11.5"
      height="11.5"
      rx="1.75"
      stroke="currentColor"
      strokeWidth="1.3"
    />
    <path
      d="M5 10.6V7.1l1.9 2.1L8.8 7.1v3.5M11 5.4h2.2M2.8 5.4H5"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      opacity=".55"
    />
  </svg>
)

export { M2 }
